$(function () {
	$("#form").validate({
		rules: {
			name: {
				required: true,
				maxlength: 20
			},
			name_kana: {
				required: true,
				maxlength: 40,
				regexKana: true
			},
			company_name: {
				maxlength: 50,
			},
			department: {
				maxlength: 20
			},
			tel: {
				rangelength: [13, 13],
				tel: true
			},
			email: {
				required: true,
				maxlength: 255,
			},
			body: {
				required: true,
				maxlength: 2000
			},
		},
		onfocusout: function (element) {
			$(element).valid();
		},
		errorPlacement: function (error, element) {
			if (element.name = "terms") {
				error.appendTo(element.parent());
			} else {
				error.insertAfter(element);
			}
		},
		errorClass: "has-text-danger is-danger",
		errorElement: "p",
		messages: {
			name: {
				required: "お名前を入力してください。",
				maxlength: "お名前は{0}文字以内で入力してください。"
			},
			name_kana: {
				required: "お名前（かな）を入力してください。",
				maxlength: "お名前（かな）は{0}文字以内で入力してください。"
			},
			company_name: {
				maxlength: "会社名は{0}文字以内で入力してください。"
			},
			department: {
				maxlength: "部署名は{0}文字以内で入力してください。"
			},
			tel: {
				rangelength: "電話番号は{0}文字入力してください"
			},
			email: {
				required: "連絡用メールアドレスを入力してください。",
				email: "正しい連絡用メールアドレスを入力してください。"
			},
			body: {
				maxlength: "お問い合わせ内容は{0}文字以内で入力してください。",
				required: "お問い合わせ内容を入力してください。",
			},
			terms: {
				required: "利用規約を確認し、同意してください。"
			}
		}
	});
	jQuery.validator.addMethod('regexKana', function (value, element) {
		return this.optional(element) || value.match(/^[ぁ-んー　]*$/);
	}, "全角かな文字で入力してください");
	jQuery.validator.addMethod('tel', function (value, element) {
		return this.optional(element) || value.match(/^[0-9\-]*$/)
	}, "数字とハイフンのみで入力してください");
});
